import React from 'react'

export default function NoFunds() {
    return (
        <>
            <div className="mx-4 mt-4 flex flex-col items-center bg-white rounded-[10px] border-[1.5px] border-dashed border-green-1 px-4 pt-8 pb-8">
                <div className="w-8 h-8 rounded-full bg-green-1 flex items-center justify-center">
                    <svg
                        className="w-5 h-5 text-white"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                        strokeWidth={2}
                    >
                        <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            d="M12 4v16m8-8H4"
                        />
                    </svg>
                </div>
                <p className="text-base font-bold text-green-1 text-center mt-4">
                    شما عضو صندوقی نیستید
                </p>
            </div>

            <div className="mx-4 mt-6 bg-[#E2EED9] border border-green-1 rounded-[10px] p-4">
                <p className="text-base font-bold text-green-1 text-right">
                    انتقال صندوق به همیان
                </p>
                <p className="text-sm font-bold text-[#4B525C] text-right mt-3">
                    اگر خارج از همیان مدیر صندوق قرض‌الحسنه‌ای دارای فعالیت و سابقه
                    هستید، با انتقال اطلاعات صندوقتان، در همیان به فعالیت ادامه
                    دهید.
                </p>
                <button className="w-full mt-6 bg-green-1 rounded-[10px] py-2.5 text-white font-bold text-sm text-center">
                    انتقال صندوق به همیان
                </button>
            </div>
        </>
    )
}
